import React from 'react';
import { Badge } from 'react-bootstrap';
import FourBettersRenderer, {
  FourBetter,
} from './FourBettersRenderer';
import SDGIconRenderer, { SDG } from './SDGIconRenderer';

interface ILinkData {
  href: string;
  label: string;
}

interface IProps {
  data: string | string[] | ILinkData;
  type?:
    | undefined
    | 'badge'
    | 'link'
    | 'fourBetters'
    | 'sdgs';
}

const RenderData: React.FC<IProps> = ({ data, type }) => {
// update renderByType signature + link case
const renderByType = (
  data: string | ILinkData,
  type?: string
) => {
  switch (type) {
    case 'badge':
      return <Badge>{data as string}</Badge>;
    case 'link': {
      const href = typeof data === 'string' ? data : data.href;
      let label = typeof data === 'string' ? data : data.label;

      // Shorten the label for display
      if (typeof data === 'string') {
        try {
          // Ensure the URL has a protocol for proper parsing.
          const fullUrl =
            data.startsWith('http://') || data.startsWith('https://')
              ? data
              : `https://${data}`;
          const url = new URL(fullUrl);
          const displayHost = url.hostname.replace(/^www\./, '');
          const hasPath = url.pathname !== '/' && url.pathname.length > 1;
          label = hasPath ? `${displayHost}/...` : displayHost;
        } catch (e) {}
      }

      return (
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>
      );
    }
    case 'fourBetters':
      return (
        <FourBettersRenderer
          fourBetter={data as FourBetter}
        />
      );
    case 'sdgs':
      return <SDGIconRenderer sdg={data as SDG} />;
    default:
      return <span>{data as string}</span>;
  }
};


  return (
    <div>
      {typeof data === 'string' && renderByType(data, type)}

      {typeof data === 'object' &&
        !Array.isArray(data) &&
        renderByType(data, type)}

      {Array.isArray(data) &&
        !type &&
        renderByType(data.join(', '), type)}

      {Array.isArray(data) && type && (
        <div
          style={{
            display: 'flex',
            gap: '0.25rem',
            flexWrap: 'wrap',
          }}
        >
          {data.map((element) =>
            renderByType(element, type)
          )}
        </div>
      )}
    </div>
  );

};

export default RenderData;
